import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";

export default function SessionAdd() {
  return (
    <div className="container mx-auto p-4">
      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Add Session</CardTitle>
          <CardDescription>
            Add new sessions to existing Scheduled Offerings
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <p className="text-lg text-muted-foreground mb-4">Coming Soon</p>
            <p className="text-sm text-muted-foreground">
              This feature will allow administrators to add additional sessions
              to existing Scheduled Offerings, set session dates and times,
              and configure session-specific details.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}